import { computed } from 'mobx';
import { IEntity, IEntityStore } from '../../main/entities';
import { MgHasher } from '../../mg/MgHasher';
import { DelegateRepo } from './DelegateRepo';

export class SortedRepo<E extends IEntity> extends DelegateRepo<E> implements IEntityStore<E> {
	constructor(delegate: IEntityStore<E>, private readonly comparator: (a: E, b: E) => number) {
		super(delegate);
	}

	@computed get allAsList() {
		return this.delegate.allAsList.slice().sort(this.comparator);
	}

	@computed get etag() {
		return new MgHasher().addString(this.delegate.etag).addArray(this.allAsList.map(e => e.id)).toString();
	}
}
